/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AreaElevationRequest', 'model/CollectionResponseMultiItemResponseElevationsResponse', 'model/CollectionResponseMultiItemResponseGradesResponse', 'model/CollectionResponsePointResponsePointElevation', 'model/ElevationsResponse', 'model/GradesResponse', 'model/LineElevationRequest', 'model/MultipointsElevationRequest', 'model/PointElevationRequest', 'model/ResponsePointElevation'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/AreaElevationRequest'), require('../model/CollectionResponseMultiItemResponseElevationsResponse'), require('../model/CollectionResponseMultiItemResponseGradesResponse'), require('../model/CollectionResponsePointResponsePointElevation'), require('../model/ElevationsResponse'), require('../model/GradesResponse'), require('../model/LineElevationRequest'), require('../model/MultipointsElevationRequest'), require('../model/PointElevationRequest'), require('../model/ResponsePointElevation'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ElevationApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.AreaElevationRequest, root.GisServerApis.CollectionResponseMultiItemResponseElevationsResponse, root.GisServerApis.CollectionResponseMultiItemResponseGradesResponse, root.GisServerApis.CollectionResponsePointResponsePointElevation, root.GisServerApis.ElevationsResponse, root.GisServerApis.GradesResponse, root.GisServerApis.LineElevationRequest, root.GisServerApis.MultipointsElevationRequest, root.GisServerApis.PointElevationRequest, root.GisServerApis.ResponsePointElevation);
  }
}(this, function(ApiClient, AreaElevationRequest, CollectionResponseMultiItemResponseElevationsResponse, CollectionResponseMultiItemResponseGradesResponse, CollectionResponsePointResponsePointElevation, ElevationsResponse, GradesResponse, LineElevationRequest, MultipointsElevationRequest, PointElevationRequest, ResponsePointElevation) {
  'use strict';

  /**
   * Elevation service.
   * @module api/ElevationApi
   * @version 1.0.0
   */

  /**
   * Constructs a new ElevationApi. 
   * @alias module:api/ElevationApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getElevationOfAreaV1 operation.
     * @callback module:api/ElevationApi~getElevationOfAreaV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ElevationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevation of a matrix of points within an area.
     * @param {String} wkt The Well Known Text (WKT) of a polygon feature to get the elevation.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.intervalDistance The distance between every two points in the area matrix. Elevation of each point will be calculated and returned. Defaults to 1000.0. The unit of measure for this distance is specified by the &lt;para&gt;IntervalDistanceUnit&lt;/para&gt; parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the IntervalDistance is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationOfAreaV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ElevationsResponse}
     */
    this.getElevationOfAreaV1 = function(wkt, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'wkt' is set
      if (wkt === undefined || wkt === null) {
        throw new Error("Missing the required parameter 'wkt' when calling getElevationOfAreaV1");
      }


      var pathParams = {
      };
      var queryParams = {
        'wkt': wkt,
        'Srid': opts['srid'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ElevationsResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/area', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getElevationOfLineV1 operation.
     * @callback module:api/ElevationApi~getElevationOfLineV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ElevationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevation of points along a line.
     * @param {String} wkt The Well Known Text (WKT) of a line feature to get the elevation.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.numberOfSegments Splits the requested line into this many segments, then calculates elevation of each point joining the segments.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {Number} opts.intervalDistance Splits the requested line into intervals of this length. The unit of measure for this distance is specified by the IntervalDistanceUnit parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the &lt;para&gt;IntervalDistance&lt;/para&gt; is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationOfLineV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ElevationsResponse}
     */
    this.getElevationOfLineV1 = function(wkt, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'wkt' is set
      if (wkt === undefined || wkt === null) {
        throw new Error("Missing the required parameter 'wkt' when calling getElevationOfLineV1");
      }


      var pathParams = {
      };
      var queryParams = {
        'wkt': wkt,
        'Srid': opts['srid'],
        'NumberOfSegments': opts['numberOfSegments'],
        'ElevationUnit': opts['elevationUnit'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ElevationsResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/line', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getElevationOfPointV1 operation.
     * @callback module:api/ElevationApi~getElevationOfPointV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponsePointElevation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevation of a point.
     * @param {Number} lat The latitude of the pont.
     * @param {Number} lon The longitude of the point.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationOfPointV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponsePointElevation}
     */
    this.getElevationOfPointV1 = function(lat, lon, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'lat' is set
      if (lat === undefined || lat === null) {
        throw new Error("Missing the required parameter 'lat' when calling getElevationOfPointV1");
      }

      // verify the required parameter 'lon' is set
      if (lon === undefined || lon === null) {
        throw new Error("Missing the required parameter 'lon' when calling getElevationOfPointV1");
      }


      var pathParams = {
        'lat': lat,
        'lon': lon
      };
      var queryParams = {
        'Srid': opts['srid'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponsePointElevation;

      return this.apiClient.callApi(
        '/api/v1/elevation/{lat},{lon}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getElevationsOfAreasV1 operation.
     * @callback module:api/ElevationApi~getElevationsOfAreasV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseMultiItemResponseElevationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevations of a matrix of points within each area in a collection (up to 100 areas maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/AreaElevationRequest>} opts.body Details of the area whose points you want elevation for, including the Well Known Text (WKT) of the polygon geometry, the distance between sample points, and the unit of measure for the response.
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.intervalDistance The distance between every two points in the area matrix. Elevation of each point will be calculated and returned. Defaults to 1000.0. The unit of measure for this distance is specified by the &lt;para&gt;IntervalDistanceUnit&lt;/para&gt; parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the IntervalDistance is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationsOfAreasV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseMultiItemResponseElevationsResponse}
     */
    this.getElevationsOfAreasV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseMultiItemResponseElevationsResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/area/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getElevationsOfLinesV1 operation.
     * @callback module:api/ElevationApi~getElevationsOfLinesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseMultiItemResponseElevationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevations of all the lines in a collection (up to 100 lines maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/LineElevationRequest>} opts.body Details of the lines whose points you want elevation for, including the Well Known Text (WKT) of the line geometry, the distance between sample points, and the unit of measure for the response.
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.numberOfSegments Splits the requested line into this many segments, then calculates elevation of each point joining the segments.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {Number} opts.intervalDistance Splits the requested line into intervals of this length. The unit of measure for this distance is specified by the IntervalDistanceUnit parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the &lt;para&gt;IntervalDistance&lt;/para&gt; is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationsOfLinesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseMultiItemResponseElevationsResponse}
     */
    this.getElevationsOfLinesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'NumberOfSegments': opts['numberOfSegments'],
        'ElevationUnit': opts['elevationUnit'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseMultiItemResponseElevationsResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/line/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getElevationsOfPointsV1 operation.
     * @callback module:api/ElevationApi~getElevationsOfPointsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponsePointResponsePointElevation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the elevations of all the points in a collection (up to 1,000 points maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/PointElevationRequest>} opts.body A list of point requests.
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getElevationsOfPointsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponsePointResponsePointElevation}
     */
    this.getElevationsOfPointsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponsePointResponsePointElevation;

      return this.apiClient.callApi(
        '/api/v1/elevation/point/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGradeOfLineV1 operation.
     * @callback module:api/ElevationApi~getGradeOfLineV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/GradesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the grade (slope) of a line, optionally split into segments.
     * @param {String} wkt The Well Known Text(WKT) of the line feature to get the grade.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.numberOfSegments Splits the requested line into this many segments, then calculates elevation of each point joining the segments.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {Number} opts.intervalDistance Splits the requested line into intervals of this length. The unit of measure for this distance is specified by the IntervalDistanceUnit parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the &lt;para&gt;IntervalDistance&lt;/para&gt; is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getGradeOfLineV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GradesResponse}
     */
    this.getGradeOfLineV1 = function(wkt, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'wkt' is set
      if (wkt === undefined || wkt === null) {
        throw new Error("Missing the required parameter 'wkt' when calling getGradeOfLineV1");
      }


      var pathParams = {
      };
      var queryParams = {
        'wkt': wkt,
        'Srid': opts['srid'],
        'NumberOfSegments': opts['numberOfSegments'],
        'ElevationUnit': opts['elevationUnit'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = GradesResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/grade/line', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGradeOfPointsV1 operation.
     * @callback module:api/ElevationApi~getGradeOfPointsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/GradesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the grade (slope) between a series of points.
     * @param {String} wkt The Well Known Text (WKT) of the multipoint feature to get the grade.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getGradeOfPointsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GradesResponse}
     */
    this.getGradeOfPointsV1 = function(wkt, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'wkt' is set
      if (wkt === undefined || wkt === null) {
        throw new Error("Missing the required parameter 'wkt' when calling getGradeOfPointsV1");
      }


      var pathParams = {
      };
      var queryParams = {
        'wkt': wkt,
        'Srid': opts['srid'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = GradesResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/grade/points', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGradesOfLinesV1 operation.
     * @callback module:api/ElevationApi~getGradesOfLinesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseMultiItemResponseGradesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the grade (slope) of each line in a collection (up to 100 lines maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/LineElevationRequest>} opts.body Details of the lines whose grade you want to find, including the Well Known Text (WKT) of the line, the distance between sample points, the unit of measure for the response.
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {Number} opts.numberOfSegments Splits the requested line into this many segments, then calculates elevation of each point joining the segments.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {Number} opts.intervalDistance Splits the requested line into intervals of this length. The unit of measure for this distance is specified by the IntervalDistanceUnit parameter.
     * @param {module:model/String} opts.intervalDistanceUnit The unit of measure in which the &lt;para&gt;IntervalDistance&lt;/para&gt; is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getGradesOfLinesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseMultiItemResponseGradesResponse}
     */
    this.getGradesOfLinesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'NumberOfSegments': opts['numberOfSegments'],
        'ElevationUnit': opts['elevationUnit'],
        'IntervalDistance': opts['intervalDistance'],
        'IntervalDistanceUnit': opts['intervalDistanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseMultiItemResponseGradesResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/grade/line/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGradesOfPointsV1 operation.
     * @callback module:api/ElevationApi~getGradesOfPointsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseMultiItemResponseGradesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the grade (slope) between each series of points in a collection (up to 1,000 points maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/MultipointsElevationRequest>} opts.body Details of the points you want to find the grade between, including the Well Known Text (WKT) of the multipoint feature, and the unit of measure for the response.
     * @param {Number} opts.srid The SRID (coordinate system) of the input feature. Defaults to 4326.
     * @param {module:model/String} opts.elevationUnit The unit of measure in which the elevation result is expressed. Defaults to \&quot;Feet\&quot;.
     * @param {module:api/ElevationApi~getGradesOfPointsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseMultiItemResponseGradesResponse}
     */
    this.getGradesOfPointsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'ElevationUnit': opts['elevationUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseMultiItemResponseGradesResponse;

      return this.apiClient.callApi(
        '/api/v1/elevation/grade/points/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

